import autocomplete from "./autocomplete.component";

const autocompleteModule = angular
  .module("app.components.autocomplete", [])
  .component("autocomplete", autocomplete);

export default autocompleteModule;



// WEBPACK FOOTER //
// ./src/components/autocomplete/autocomplete.module.js